var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import callTokenEndpoint from './util/callTokenEndpoint';
import handleTokenError from './util/handleTokenError';
const getAccessTokenRefreshToken = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const tokenResult = yield callTokenEndpoint(new URLSearchParams({
        grant_type: 'refresh_token',
        client_id: request.clientId,
        refresh_token: request.refreshToken,
    }));
    if ('error' in tokenResult) {
        throw handleTokenError(tokenResult);
    }
    return tokenResult;
});
export default getAccessTokenRefreshToken;
//# sourceMappingURL=getAccessTokenRefreshToken.js.map